import gql from 'graphql-tag';
import { ASSET_FRAGMENT } from '@vendure/admin-ui/core';

export const PRODUCT_REVIEW_FRAGMENT = gql`
    fragment ProductReview on ProductReview {
        id
        createdAt
        updatedAt
        authorName
        authorLocation
        summary
        body
        rating
        state
        upvotes
        downvotes
        response
        responseCreatedAt
        featuredAsset {
            ...Asset
        }
    }
    ${ASSET_FRAGMENT}
`;

export const DELETE_PRODUCT_REVIEWS = gql`
  mutation DeleteProductReviews($ids: [ID!]!) {
    deleteProductReviews(ids: $ids) {
      id
      result
      message
    }
  }
`;
